import { createTheme } from "@mui/material/styles";

const default_theme = createTheme({
    palette: {
        primary: {
            main: '#ffffff',
            other: '#f8f8f8',
            green: '#0fe880',
            gray: '#2c2c2c',
            white: "#faf0dc",
            black: '#000000',
        },
        secondary: {
            main: '#24576B',
            other: '#BCE4FA',
            green: '#8EC043',
        },
        font: {
            white: "#faf0dc",
            gray: "#606060",
            darkGray: '#3b3b3b',
        },
        border: {
            white: '#e0e0e0',
            gray:'#2c2c2c',
            inputDefault: 'rgba(0, 0, 0, 0.23)',
            inputFocused: 'rgba(0, 0, 0, 0.87)',
            subtle: 'rgba(0,0,0,0.1)',
            subtleHover: 'rgba(0,0,0,0.2)',
            subtleLight: 'rgba(0,0,0,0.08)',
            subtleLighter: 'rgba(0,0,0,0.05)',
        },
        background: {
            main: '#fafafa'
        },
        other: {
            main: '#13A89E',
            figmaBlue: "#35B3AB",
            chatGreen: '#00b894',
            chatGreenHover: '#00a085',
            turquoise: '#00C896',      
            blue: '#4A90E2',          
            purple: '#9C27B0',      
            green: '#4CAF50',       
            lightGreen: '#8BC34A',   
            pink: '#E91E63',         
            orange: '#FF9800',       
            red: '#FF6B6B',           
            brown: '#795548',         
            blueGrey: '#607D8B',      
            skyBlue: '#2196F3',       
            white: '#f5f5f5',
            lightBlue: '#E3F2FD',     
            lightPurple: '#F3E5F5',
            darkBlue: '#34495e',
            addButtonBlue: '#23576B',
            addHoverButtonBlue: '#7898A4',
            paleGreen: '#E8F5E8',            
            lightOrange: '#FFF3E0',   
            backgroundGrey: '#f8f9fa',
            textDark: '#333',     
            textSecondary: '#666',  
            tealHover: '#E0F7F6',   
            tealDark: '#0F8A81',
            overlaySoft: 'rgba(255, 255, 255, 0.7)',
            overlaySubtle: 'rgba(255, 255, 255, 0.1)',
            overlayBorder: 'rgba(255, 255, 255, 0.5)',
            drawerShadow: '2px 0 12px rgba(0,0,0,0.12)',
            cardShadow: '0 12px 24px rgba(0,0,0,0.1)',
            hoverLight: 'rgba(0,0,0,0.04)',
            backgroundSubtle: 'rgba(0,0,0,0.02)',
            textMuted: 'rgba(0, 0, 0, 0.6)',
            textDisabledCustom: 'rgba(0, 0, 0, 0.38)',
            tealBackgroundSoft: 'rgba(19, 168, 158, 0.08)',
            socialWhatsApp: '#25D366',
            socialGoogle: '#EA4335',
            socialLinkedIn: '#0058CC',
            linkBlue: '#1976d2',
            accentBlue: 'rgb(66, 165, 245)',
        },
    },
    components: {
        // palette.primary.main is reserved as a literal white in this app, so
        // components that fall back to color="primary" render white/invisible on
        // light backgrounds. Fix the defaults here (explicit color/sx still wins).
        MuiCircularProgress: {
            defaultProps: {
                // Spinners inherit the surrounding text colour instead of white.
                color: 'inherit',
            },
        },
        MuiTabs: {
            defaultProps: {
                // Selected tab label + indicator otherwise use primary (white).
                textColor: 'secondary',
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#35B3AB',
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-focused': {
                        color: '#35B3AB',
                    },
                },
            },
        },
    },
})

export default default_theme;